import { type UserOrderCarrierV2 } from '@redteclab/api/clients/composition-service-account'

import { type PublicGlobalConfig } from '../../global-config'
import { urlResolverGetTrackShippingInfo } from '../../url-handling'

export const userSubOrderAccessorGetTrackingUrl = (
  config: PublicGlobalConfig,
  carrier: UserOrderCarrierV2 | undefined,
): string | undefined => {
  const trackingUrl = carrier?.trackingUrl

  if (trackingUrl && URL.canParse(trackingUrl)) {
    const url = new URL(trackingUrl)

    if (url.protocol === 'http:' || url.protocol === 'https:') {
      return url.href
    }
  }

  if (carrier?.trackingId) {
    return urlResolverGetTrackShippingInfo(config, { carrier })
  }

  return undefined
}
